export default "__VITE_ASSET__CteHnHRd__"